import React from "react";

const PurchaseOrderDetail = () => {
  return <div>PurchaseOrderDetail</div>;
};

export default PurchaseOrderDetail;
